'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minuteAgo.js
// module id = 705
// module chunks = 0